"use client";

import Link from "next/link";

import { Home, Search } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/shared/ui/button";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex h-dvh flex-col items-center justify-center px-4">
      <div className="animate-in fade-in slide-in-from-bottom-4 flex flex-col items-center space-y-6 duration-500">
        <div className="relative select-none">
          <span className="text-muted-foreground/10 text-[10rem] leading-none font-black tracking-tighter">404</span>
          <Search
            className="text-muted-foreground/40 absolute top-1/2 left-1/2 h-16 w-16 -translate-x-1/2 -translate-y-1/2 animate-pulse"
            strokeWidth={1.5}
          />
        </div>

        <div className="animate-in fade-in slide-in-from-bottom-2 space-y-2 text-center delay-200 duration-500">
          <h1 className="text-2xl font-semibold tracking-tight">{t("feedback.pageNotFound.title")}</h1>
          <p className="text-muted-foreground max-w-md text-sm">{t("feedback.pageNotFound.description")}</p>
        </div>

        <div className="animate-in fade-in slide-in-from-bottom-2 delay-500 duration-500">
          <Button asChild variant="outline" className="gap-2">
            <Link prefetch={false} replace href="/app/wholesale-offers">
              <Home className="h-4 w-4" />
              {t("common.actions.goHome")}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
